<ng-container>
    <mat-checkbox #multicheckbox class="pl-12 pr-12" *ngFor="let item of array" [class.d-none]="(hasConvocatoria && item.id === 'diploma')"
                  (change)="setCheckBoxValuesByKey($event.checked, item.id)">
        {{item.name}}
    </mat-checkbox>
</ng-container>

